export const deleteConfimationInputValue = "PERMANENTLY DELETE";

export const deleteProjectDetailListClassName = "delete-project-detail-list";

export const deleteProjectDetailListLabelClassName = `${deleteProjectDetailListClassName}__label`;

export const deleteProjectDetailListValueClassName = `${deleteProjectDetailListClassName}__value`;
